import {SignIn, SignUp} from "@clerk/react";
import {LOGO_ON_TOSCA} from "@/lib/inner";

const Art = () => <div className="cms-auth-art"><img src={LOGO_ON_TOSCA} alt="INNER Salon Muslimah"/><h1>Kelola website<br/><em>dengan tenang.</em></h1><p>Area admin website INNER Salon Muslimah: menu, harga, outlet, dan paket favorit.</p></div>;

export const CmsSignIn = () => <main className="cms-auth"><Art/><div className="cms-auth-form"><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp/></div></main>;
export const CmsSignUp = () => <main className="cms-auth"><Art/><div className="cms-auth-form"><SignUp routing="path" path="/sign-up" signInUrl="/sign-in"/></div></main>;
